import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d8f614"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "tab-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "navRef",
    class: _normalizeClass(["column-tabs-nav", { dragging: _ctx.isDragging, 'is-light': _ctx.isLight }]),
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args)))
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.columnCode,
          class: _normalizeClass(["column-tab-item", { active: item.columnCode === _ctx.modelValue }]),
          onClick: ($event: any) => (_ctx.clickTab(item, index, $event))
        }, [
          (_ctx.showImage && item.coverImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.coverImage,
                class: "tab-icon",
                alt: ""
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.columnName), 1)
        ], 10, _hoisted_1))
      }), 128))
    ])
  ], 34))
}